<script setup>
import { RouterLink, useRouter } from 'vue-router'
import * as Auth from '@/services/Auth'

const router = useRouter()

const workInProgress = () => {
  alert("Work in progress! This tournament is not available yet.")
}
</script>

<template>
  <main>
    <v-container>
      <div v-if="!Auth.isAuthenticated()">
        <div class="d-flex justify-center align-center my-12">
          <v-card max-width="600" class="text-center pa-8" elevation="8">
            <v-icon size="80" color="primary" class="mb-4">mdi-tournament</v-icon>
            
            <h1 class="text-h4 mb-4">{{ $t('app.welcomeTitle') }}</h1>
            
            <p class="text-medium-emphasis mb-6">
              {{ $t('app.welcomeMessage') }}
            </p>

            <v-btn
              :to="{ name: 'login' }"
              color="primary"
              size="x-large"
              variant="elevated"
              class="px-12"
            >
              <v-icon start>mdi-login</v-icon>
              {{ $t('common.login') }}
            </v-btn>
          </v-card>
        </div>
      </div>

      <div v-else>
        <v-card class="mt-8 mb-6" elevation="0" color="transparent">
          <v-card-text class="text-center">
            <h2 class="text-h4 mb-3">{{ $t('app.welcomeTitle') }}</h2>
            <p class="text-body-1 text-medium-emphasis">
              {{ $t('app.welcomeMessage') }}
            </p>
          </v-card-text>
        </v-card>

        <v-row justify="center" class="mb-8">
          <v-col cols="12" md="4">
            <v-card
              :to="{ name: 'dashboard' }"
              hover
              class="text-center pa-6"
              elevation="2"
            >
              <v-icon size="48" color="primary" class="mb-3">mdi-view-dashboard</v-icon>
              <v-card-title class="justify-center">{{ $t('label.dashboard') }}</v-card-title>
              <v-card-text class="text-medium-emphasis">
                {{ $t('app.dashboardDescription') }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>



    
      <div class="text-center">
        <h2 class="text-h4 mb-4">
          {{ $t('label.examples') }}
        </h2>
      </div>

      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card class="pa-4 my-4">
            <v-card-text>
              <v-list>
                <v-list-item prepend-icon="mdi-tournament"
                  link
                  :to="{ name: 'tournament-show', params: { slug: 'world-cup' } }"
                  class="pa-4"
                >
                  <v-list-item-title>Old style World Cup</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('competitionTypes.round_robin') }} + {{ $t('competitionTypes.knockout') }}</v-list-item-subtitle>
                </v-list-item>

                <!-- <v-list-item prepend-icon="mdi-flag-checkered"
                  link
                  :to="{ name: 'tournament-show', params: { slug: 'gpor-formula-d' } }"
                  class="pa-4"
                >
                  <v-list-item-title>Formula 1 Season</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('competitionTypes.ffa') }}</v-list-item-subtitle>
                </v-list-item> -->

                <v-list-item prepend-icon="mdi-flag-checkered"
                  link
                  :to="{ name: 'tournament-show', params: { slug: 'gpor-formula-teams' } }"
                  class="pa-4"
                >
                  <v-list-item-title>Formula 1 Season</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('competitionTypes.ffa') }}</v-list-item-subtitle>
                </v-list-item>

                <v-list-item prepend-icon="mdi-trophy"
                  link
                  @click="workInProgress"
                  class="pa-4"
                >
                  <v-list-item-title>Champions League</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('competitionTypes.swiss') }} + {{ $t('competitionTypes.knockout') }}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>
